export default __webpack_public_path__ + "static/media/logo-pulsehd.1d2c9e31.svg";